<template>
  <div
    class="d-flex"
    style="height: 100vh !important;"
  >
    <div v-if="supportsFullAnalysis && tab_value !== 0" style="height: 100%; width: 15px; overflow-y: scroll;" class="hide-scrollbar">
      <side-bar-events
        :colorFunc="colorFunc()"
      />
    </div>
    <div style="height: 100%; width: calc(100% - 20px); overflow-y: scroll;" class="d-flex-col flex-grow-1">
      <div v-if="loading_stuff" class="d-flex flex-column justify-center align-center pt-10">
        <div>
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <div class="mt-3 font-weight-bold" v-if="loading_game">Loading game data...</div>
        <div class="mt-3 font-weight-bold" v-if="loading_leagues">Loading leagues...</div>
        <div class="mt-3 font-weight-bold" v-if="loading_game_players">Loading players...</div>
        <div class="mt-3 font-weight-bold" v-if="loading_game_stadion">Loading stadion...</div>
        <div class="mt-3 font-weight-bold" v-if="loading_game_referee">Loading referee...</div>
        <div class="mt-3 font-weight-bold" v-if="loading_events">Loading events...</div>
      </div>
      <RawPesistuloksetAnalysis
        v-else-if="!supportsFullAnalysis"
        class="pa-2"
      />
      <LiveModeWarning v-else-if="!should_clip"/>
      <v-tabs
        v-else
        style="height: 50px;"
        v-model="tab_index"
        grow
        center-active
        dense
        @change="handleTabChange"
      >
        <v-tab
          v-for="tab in filteredTabs"
          :key="tab.name"
          v-tooltip="tabText(tab)"
        >
          <v-icon>{{ tabIcon(tab) }}</v-icon>
        </v-tab>
      </v-tabs>
      <div class="pa-2" v-if="supportsFullAnalysis && should_clip">
        <!-- BODY -->
        <component
          v-if="currentTab && !loading_stuff"
          :is="currentTab.component"
          :key="currentTab.component"
          ref="current_phase"
          @deleteEvent="deleting_event_id = $event"
          @pickOffLatest="pickOffLatest()"
          @hittersRanOut="hittersRanOut()"
          @eventSaved="handleCurrentTabEventSaved"
        />
      </div>
    </div>
    <confirmation-dialog
      v-if="deleting_event_id"
      :show="deleting_event_id"
      btnColor="error"
      btnText="Poista"
      subText="Haluatko varmasti poistaa tapahtuman?"
      @accept="startDeleteEvent(deleting_event_id)"
      @decline="deleting_event_id = null"
    ></confirmation-dialog>
  </div>
</template>

<script>
import GameLineups from '@/components/analysis/GameLineups.vue';
import EventDetailsAnalysis from '@/components/analysis/EventDetailsAnalysis.vue';
import MadeOutsAnalysis from '@/components/analysis/MadeOutsAnalysis.vue';
import HitMapAnalysis from '@/components/analysis/HitMapAnalysis.vue';
import RunTimingAnalysis from '@/components/analysis/RunTimingAnalysis.vue';
import { mapGetters, mapMutations } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { getNewState } from '@/utils/analysis/analysisHelper';
import { mapActions } from 'vuex/dist/vuex.common.js';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import SideBarEvents from '@/components/analysis/side_events/SideBarEvents.vue';
import LiveModeWarning from '@/components/video/analysisBar/LiveModeWarning.vue';
import RawPesistuloksetAnalysis from '@/components/analysis/RawPesistuloksetAnalysis.vue';

export default {
  components: {
    GameLineups,
    EventDetailsAnalysis,
    MadeOutsAnalysis,
    ConfirmationDialog,
    SideBarEvents,
    HitMapAnalysis,
    RunTimingAnalysis,
    LiveModeWarning,
    RawPesistuloksetAnalysis
  },
  data: () => ({
    tab_value: 0,
    full_analysis_leagues: ['msu', 'nsu', 'myp', 'nyp'],
    tabs: [
      { value: 0, leagues: ['all'], name: 'Lineup', component: 'GameLineups', icon: 'mdi-account-group-outline', text: 'Lineup' },
      { value: 1, leagues: ['all'], name: '1.', component: 'EventDetailsAnalysis', eventSavedHandler: 'handleEventSaved', icon: 'mdi-numeric-1', text: '1. vaihe' },
      { value: 2, leagues: ['msu', 'nsu'], name: '2.', component: 'MadeOutsAnalysis', eventSavedHandler: 'madeOutsEventSaved', icon: 'mdi-numeric-2', text: '2. vaihe' },
      { value: 3, leagues: ['msu', 'nsu', 'myp', 'nyp'], name: '3.', component: 'HitMapAnalysis', eventSavedHandler: 'secondPhaseEventSaved', icon: 'mdi-numeric-3', text: '3. vaihe' },
      { value: 4, leagues: ['msu', 'nsu', 'myp'], name: '4.', component: 'RunTimingAnalysis', eventSavedHandler: 'thirdPhaseEventSaved', icon: 'mdi-numeric-4', text: '4. vaihe' },
    ],
    deleting_event_id: null
  }),
  created() {
    let tab = this.$route.query.tab
    if(tab) {
      this.tab_value = parseInt(tab)
    }

    let analysisPhase = this.$route.query.analysis_phase
    if(analysisPhase) this.tab_value = this.tabValueFromAnalysisPhase(analysisPhase)
  },
  methods: {
    tabValueFromAnalysisPhase(analysisPhase) {
      const phase = parseFloat(analysisPhase)
      if(phase > 2 && phase < 3) return 3
      if(phase === 3) return 4
      return parseInt(analysisPhase)
    },
    tabIcon(tab) {
      if(tab.value === 3 && this.video?.pesis_league_name === 'nyp') return 'mdi-numeric-2'
      return tab.icon
    },
    tabText(tab) {
      if(tab.value === 3 && this.video?.pesis_league_name === 'nyp') return '2. vaihe'
      return tab.text
    },
    colorFunc() {
      if(this.tab_value === 2) {
        return e => {
          if(e?.made_outs?.length) return '#2C57FB'
          return 'lightgrey'
        }
      }

      if (this.tab_value === 3) {
        return (e) => {
          if (!e || typeof e.phase_done !== 'number') {
            console.warn("Invalid input:", e);
            return "#808080"; // Fallback to grey if input is invalid
          }

          const value = e.phase_done;

          if (value < 2.0) {
            return "#808080"; // Grey
          } else if (value > 2.5) {
            return "#2C57FB"; // Almost black blue
          }

          // Map value from range [2.0, 2.5] to a much wider color gradient
          let blueIntensity = Math.round(255 - ((value - 2.0) / 0.5) * (255 - 50));
          let redGreenTint = Math.round(173 - ((value - 2.0) / 0.5) * (173)); // Reduce R/G for darker blue

          return `rgb(${redGreenTint}, ${redGreenTint + 40}, ${blueIntensity})`;
        };
      }

      if(this.tab_value > 3) {
        const val = this.tab_value - 1
        return e => {
          if(e.phase_done >= val) return '#2C57FB'
          return 'lightgrey'
        }
      }

      return null
    },
    handleTabChange(index) {
      const tab = this.filteredTabs[index]
      if(!tab) return

      this.tab_value = tab.value
      this.$router.replace({ query: { ...this.$route.query, tab: tab.value } })
    },
    handleCurrentTabEventSaved(event) {
      const handler = this.currentTab?.eventSavedHandler
      if(!handler || !this[handler]) return

      this[handler](event)
    },
    ensureVisibleTab() {
      if(!this.video?.pesis_league_name) return
      if(!this.filteredTabs.length) return
      if(this.filteredTabs.some(tab => tab.value === this.tab_value)) return

      this.tab_value = this.filteredTabs[0].value
    },
    startDeleteEvent(event_id) {
      this.deleteEvent(event_id)
        .then(() => {
          this.info('Poisto onnistui')
          this.deleting_event_id = null
        })
        .catch(e => {
          this.error(e)
        })
    },
    hittersRanOut() {
      const event = JSON.parse(JSON.stringify(this.events[this.events.length - 1]))

      let new_event = this.formNewEventFromOld(event, true)

      this.SET_CREATING_EVENT(new_event)
    },
    formNewEventFromOld(old_event, ran_out=false) {
      let ne = getNewState(old_event, this.game_players, ran_out)
      ne = JSON.parse(JSON.stringify(ne)) // bugs wihout this javasctipt is fun!!

      const keys = Object.keys(this.$refs.current_phase.emptyState())
      ne = keys.reduce((acc, key) => {
        if (key in ne) {
          acc[key] = ne[key];
        }
        return acc;
      }, {});

      return ne
    },
    pickOffLatest() {
      if(!this.events || !this.events.length) {
        this.info('Ei tapahtumia. Paina a.')
        return;
      }

      const event = JSON.parse(JSON.stringify(this.events[this.events.length - 1]))
      let ne = this.formNewEventFromOld(event)
      this.SET_CREATING_EVENT(ne)
      this.success('Siirrytty! Voit jatkaa tästä.')
      this.seek(event.endtime)
    },
    handleEventSaved() {
      if(this.current_event.event_id) {
        this.updateEvent({ event: this.current_event, updateRunTime: this.current_event.run, updatePlayTime: this.current_event.play })
          .then(() => {
            this.success('Päivitys onnistui')
            this.track('Event updated', { ...this.current_event, phase: 1, phase_name: 'Ensimmäinen vaihe', new_event: false })
          })
          .catch(e => {
            this.error(e)
          })
        return
      }

      const additional_data = {
        season_year: this.video.season_starttime_year,
        season_id: this.video.season_id,
        season_state: this.video.season_state,
        stream_url: this.video.video_url,
        game_id: this.video.id,
        home_team_id: this.video.home_club_id,
        away_team_id: this.video.away_club_id,
        pitching_referee_name: this.referee?.name,
        pitching_referee_id: this.referee?.id,
        stadion_id: this.stadium?.id,
        stadion_name: this.stadium?.name,
        date: this.video.starttime_unix,
        league_id: this.video.league_id
      }

      let cur = JSON.parse(JSON.stringify(this.current_event))

      let old_event = {
        ...additional_data,
        ...cur,
        event_id: uuidv4(),
      }
      old_event = JSON.parse(JSON.stringify(old_event))

      this.createEvent(old_event)
        .then(() => {
          this.track('Event updated', { ...old_event, phase: 1, phase_name: 'Ensimmäinen vaihe', new_event: true })
        })
        .catch((e) => {
          this.error(e)
        })

      const hitter = this.game_players[old_event.hitting].find(player => player.id === old_event.hitter_id)
      if(hitter.hits_from_left === null) {
        this.setHitterSide({ player_id: hitter.id, hits_from_left: old_event.hitter_side === "L", side: old_event.hitting })
          .then(() => {
            this.success('Lyöntipuoli ok!')
          })
          .catch(e => {
            this.error(e)
          })
      }

      const new_event = this.formNewEventFromOld(old_event)
      this.SET_CREATING_EVENT(new_event)

      this.setHitterSide({ player_id: hitter.id, hits_from_left: old_event.hitter_side === "L", side: old_event.hitting })
        .catch(e => {
          this.error(e)
        })
    },
    secondPhaseEventSaved(event) {
      this.updateEvent({ event })
        .then(() => {
          this.openNextEvent()
          this.success('Päivitys onnistui')
          this.track('Event updated', { ...event, phase: 2, phase_name: 'Kartat & tietoa' })
        })
        .catch(e => {
          this.error(e)
        })
    },
    madeOutsEventSaved(event) {
      this.updateEvent({ event })
        .then(() => {
          this.openNextEvent()
          this.success('Päivitys onnistui')
          this.track('Event updated', { ...event, phase: 2, phase_name: 'Palojen tekijät' })
        })
        .catch(e => {
          this.error(e)
        })
    },
    thirdPhaseEventSaved(event) {
      this.updateEvent({ event, updateRunTime: true })
        .then(() => {
          this.openNextEvent()
          this.success('Päivitys onnistui')
          this.track('Event updated', { ...event, phase: 3, phase_name: 'Aikojen mittaus', new_event: false })
        })
        .catch(e => {
          this.error(e)
          console.log(e)
        })
    },
    openEvent(event) {
      this.startEditingEvent(event.event_id)
      this.seek(event.starttime - 2)
    },
    ...mapMutations('analysis', [
      'SET_CREATING_EVENT'
    ]),
    ...mapActions({
      startEditingEvent: 'analysis/startEditingEvent',
      seek: 'player/seek',
    }),
    ...mapActions('analysis', [
      'createEvent',
      'updateEvent',
      'startEditingEvent',
      'deleteEvent',
      'setHitterSide',
      'openNextEvent'
    ]),
    ...mapActions('noti', [
      'error',
      'success',
      'info'
    ]),
    ...mapActions('player', [
      'seek'
    ]),
    ...mapActions('game', [
      'setHitterSide'
    ])
  },
  computed: {
    ...mapGetters('videos', [
      'loading_game',
      'video'
    ]),
    ...mapGetters('admin', [
      'loading_leagues'
    ]),
    ...mapGetters('game', [
      'loading_game_players',
      'loading_game_stadion',
      'loading_game_referee',
      'game_players',
      'referee',
      'stadium'
    ]),
    ...mapGetters('analysis', [
      'current_event',
      'events',
      'loading_events'
    ]),
    ...mapGetters('player', [
      'dvr_in_use',
      'dvr_enabled'
    ]),
    should_clip() {
      return this.dvr_in_use && this.dvr_enabled || !this.dvr_enabled
    },
    tab_index: {
      get() {
        const index = this.filteredTabs.findIndex(tab => tab.value === this.tab_value)
        return index === -1 ? 0 : index
      },
      set(index) {
        const tab = this.filteredTabs[index]
        if(tab) this.tab_value = tab.value
      }
    },
    loading_stuff() {
      return this.loading_game || this.loading_leagues || this.loading_game_players || this.loading_game_stadion || this.loading_game_referee || this.loading_events
    },
    supportsFullAnalysis() {
      return this.full_analysis_leagues.includes(this.video?.pesis_league_name)
    },
    filteredTabs() {
      return this.tabs.filter(t => {
        return t.leagues.includes('all') || t.leagues.includes(this.video?.pesis_league_name)
      })
    },
    currentTab() {
      return this.filteredTabs.find(tab => tab.value === this.tab_value)
    }
  },
  watch: {
    'video.pesis_league_name': {
      handler() {
        this.ensureVisibleTab()
      },
      immediate: true
    },
    events: {
      handler() {
        setTimeout(() => {
          if(this.$route.query.event_id) {
            this.openEvent(this.events.find(e => e.event_id === this.$route.query.event_id))
          }
        }, 300)
      },
      immediate: false
    }
  }
}
</script>

<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;             /* Chrome, Safari and Opera */
}
</style>